export default __webpack_public_path__ + "images/image8.3e77adca.png";